import React from "react";
import styles from "./Address.module.css";
import AddressInfo from "./AddressInfo/AddressInfo";
import OrderList from "./OrderList/OrderList";

const Address = (props) => {
  const isMobile = (window.innerWidth <= 768) ? true : false;

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <AddressInfo deliveryAddress={props.deliveryAddress} setDeliveryAddress={props.setDeliveryAddress}
          billingAddress={props.billingAddress} setBillingAddress={props.setBillingAddress}
          useSameAddress={props.useSameAddress} setUseSameAddress={props.setUseSameAddress} />
        <div className={styles.actions}>
          <button type="button" className={styles.backButton} onClick={() => props.setCurrentStep(0)}><i className="fa-solid fa-chevron-left" /> Inapoi</button>
          <button type="submit" className={styles.nextButton} onClick={() => props.setCurrentStep(2)}>Înainte<i className="fa-solid fa-chevron-right" /></button>
        </div>
      </div>
      {isMobile || <div className={styles.cartSummary}>
        <OrderList cart={props.cart} />
      </div>}
    </div>
  );
};

export default Address;